export class AppSettings {


  public static get API_KEYTOKEN(): string {

    let origen = window.location.origin;

    if (origen == "http://localhost:4200"){
      return '421aa90e079fa326b6494f812ad13e79';
    }else if(origen == "http://beta.admin.danubio.normapro.es"){
      return '6d9601056274c528a384576190173060';
    }else if(origen == "http://dev.admin.danubio.normapro.es" ||origen == "http://dev0.admin.danubio.normapro.es" || origen == "http://dev1.danubio.normapro.es" || origen == "http://dev2.admin.danubio.normapro.es" || origen == "http://dev3.admin.danubio.normapro.es"){
      return '421aa90e079fa326b6494f812ad13e79';
    }else if(origen == "http://admin.danubio.normapro.es"){
      return '555e787f8d383e052eae351f71ed8655';
    }else if(origen == "https://admin.danubio.normapro.es"){
      return '555e787f8d383e052eae351f71ed8655';
    }

  }
  public static get API_URL(): string {

    let origen = window.location.origin;

    if (origen == "http://localhost:4200"){
      return 'https://dev1.api.danubio.normapro.es/';
    }else if(origen == "http://beta.admin.danubio.normapro.es"){
      return 'http://beta.api.danubio.normapro.es/';
    }else if(origen == "http://admin.danubio.normapro.es"){
      return 'http://api.danubio.normapro.es/';
    }else if(origen == "http://dev0.admin.danubio.normapro.es" ){
      return 'http://dev0.api.danubio.normapro.es/';
    }else if(origen == "http://dev1.admin.danubio.normapro.es" ){
      return 'http://dev1.api.danubio.normapro.es/';
    }else if(origen == "http://dev2.admin.danubio.normapro.es" ){
      return 'http://dev2.api.danubio.normapro.es/';
    }else if(origen == "http://dev3.admin.danubio.normapro.es" ){
      return 'http://dev3.api.danubio.normapro.es/';
    }else if(origen == "http://dev.admin.danubio.normapro.es" ){
      return 'http://dev.api.danubio.normapro.es/';
    }else if(origen == "https://admin.danubio.normapro.es"){
      return 'https://api.danubio.normapro.es/';
    }
  }

  public static get ENTORNO(): string {

    let origen = window.location.origin;

    if (origen == "http://localhost:4200"){
      return 'desarrollo';
    }else if(origen == "http://beta.admin.danubio.normapro.es"){
      return 'beta';
    }else if(origen == "http://admin.danubio.normapro.es"){
      return 'produccion';
    }else if(origen == "https://admin.danubio.normapro.es"){
      return 'produccion';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/_models/settings.models.ts